import { getOrigin } from 'core-lib/config/config';
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-arrow-callback */
import { DETAIL_KEYS } from '../constants/variants';
import { WEBSITE_URL } from 'core-lib/data/common';
import { toTitleCase } from 'core-lib/utils/utils';

export const formatPrice = (value: number) => {
  if (!value || Number.isNaN(value)) {
    return 'N/A';
  }
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    notation: 'compact',
    compactDisplay: 'long',
  });
  return formatter.format(value);
};

export const toPascalCase = (s) => {
  if (s && typeof s === 'string') {
    return s?.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
      return g1.toUpperCase() + g2.toLowerCase();
    });
  }
  return s;
};

export const slugToTitle = (slug) => {
  const slugStrings = slug.join('-').split('-');
  const removedStrings = ['car', 'body', 'type'];
  const filteredSlug = slugStrings
    .filter((x) => !removedStrings.includes(x))
    .join(' ');
  const itemListTitle = 'Best ' + toTitleCase(filteredSlug) + ' Cars In India ';
  return itemListTitle;
};

export function filterAndOrganiseSpecifications(obj) {
  if (!obj || Object.keys(obj).length === 0) {
    return null;
  }

  const newObj = {};

  Object.keys(obj).forEach((key) => {
    const specsKey = obj[key];
    const res = {};

    Object.keys(specsKey).forEach((elKey) => {
      if (specsKey[elKey] != null && specsKey[elKey] !== '-') {
        res[elKey] = specsKey[elKey];
      }
    });

    if (Object.keys(res).length > 0) {
      newObj[DETAIL_KEYS[key]] = res;
    }
  });
  if (Object.keys(newObj).length === 0) {
    return null;
  }
  return newObj;
}

const { ENV } = process.env;
const LOCAL_HOST = 'http://localhost:3001';

export function getAbsolutePath(asPath, query) {
  if (!asPath || !query) {
    return '';
  }
  // const origin = WEBSITE_URL;
  return `${WEBSITE_URL}${asPath}/${query}`;
}
export function slugPath(asPath, slug) {
  if (!slug) {
    return '';
  }
  const origin = getOrigin();
  //For clientSide
  if (origin && asPath?.includes('pwa')) {
    return `${origin}/pwa/new-cars/${slug}`;
  } else {
    //For ServerSide
    // eslint-disable-next-line no-lonely-if
    // if (ENV === 'production') {
    return `${WEBSITE_URL}/new-cars/${slug}`;
    // } else {
    //   return `${LOCAL_HOST}/new-cars/${slug}`;
    // }
  }
}

export function slugify(str) {
  if (str?.length && typeof str === 'string') {
    return str?.replace(/ /g, '-');
  }
  return '';
}

export function getOptions(data) {
  const transmission = [];
  const fuelTypes = [];
  if(data){
    for (const obj of data) {
      if (!transmission.includes(obj.transmission)) {
        transmission.push(obj.transmission);
      }
      if (!fuelTypes.includes(obj.fuelType)) {
        fuelTypes.push(obj.fuelType);
      }
    }
  }
  return { fuel: fuelTypes, transmission: transmission };
}
